export default function({ app, route, store, redirect }) {
  const routeHaveLocale = /\/(pt|en)/.test(route.fullPath)

  if (routeHaveLocale) {
    return
  }

  redirect(`/${store.state.i18n.locale}${route.fullPath}`)
}
